import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RackZoneByIdDto } from './dto/rack-zone-map-dto';
import { RackZoneDtoActive } from './dto/rack-zone-mapping-active.dto';
import { RackZoneMappingDtO } from './dto/rack-zone-mapping-dto';
import { RackZoneMappingService } from './rack-zone-mapping.service';
import { AllRackZoneMapResponseModel, RackZoneEmpMapResponseModel, RackZoneMappingResponseModel, RackZonemapResponse, RackZoneRequest } from '@gtpl/shared-models/masters';
import { RackZoneEndCustResponse } from './dto/rack-zone-end-cust.response';

@ApiTags('rack-zone-mapping')
@Controller('rack-zone-mapping')
export class RackZoneMappingController {

    constructor(private rackZoneService: RackZoneMappingService,private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/CreateRackZone')
    async CreateRackZone(@Body() rackZoneMappingDtO: RackZoneMappingDtO): Promise<RackZoneMappingResponseModel>  {
      try {
        return await this.rackZoneService.CreateRackZone(rackZoneMappingDtO, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(RackZoneMappingResponseModel, error);
      }
    }
  
  
    @Post('/updateRackZone')
    async updateRackZone(@Body() rackZoneMappingDtO: RackZoneMappingDtO): Promise<RackZoneMappingResponseModel>  {
      try {
        return await this.rackZoneService.CreateRackZone(rackZoneMappingDtO, true);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(RackZoneMappingResponseModel, error);
      }
    }
  
  
    @Post('getRecordByRackZoneId')
    async getRecordByRackZoneId(@Body() id: RackZoneByIdDto): Promise<RackZoneEmpMapResponseModel> {
      try {
        console.log(id);
        return await this.rackZoneService.getRecordByRackZoneMapId(id.rackZoneMappingId);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(RackZoneEmpMapResponseModel, error);
      }
    }
    @Post('getAllRackZone')
    async getAllRackZone():Promise<AllRackZoneMapResponseModel> {
      try {
        return await this.rackZoneService.getAllRackZone();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(AllRackZoneMapResponseModel, error);
      }
    }
    @Post('activateorDeactivateRackZone')
    async activateorDeactivateRackZone(@Body() rackZoneAct: RackZoneDtoActive):Promise<RackZonemapResponse> {
      try {
        return await this.rackZoneService.activateorDeactivateRackZone(rackZoneAct);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(RackZonemapResponse, error);
      }
    } 
    @Post('getAllRacksByEndCustomer')
    async getAllRacksByEndCustomer(@Body() rackZoneEndCustResponse: RackZoneEndCustResponse):Promise<AllRackZoneMapResponseModel> {
      try {
        return await this.rackZoneService.getAllRacksByEndCustomer(rackZoneEndCustResponse);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(AllRackZoneMapResponseModel, error);
      }
    } 
}
